import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.jpeg";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* LEFT: LOGO + COLLEGE INFO */}
        <div className="footer-left">
          <img src={logo} alt="College Logo" className="footer-logo" />

          <h3>BLUE MOON DEGREE COLLEGE</h3>

          <p className="footer-address">
            Near Gangamma Mori, N.H.205, Kutagulla – 515 541,<br />
            Kadiri, Sri Satya Sai District, Andhra Pradesh
          </p>

          <p className="footer-phone">
            📞 9491703509, 7901628736, 9849789456, 9492039384
          </p>

          <p className="footer-email">
            📧 Email:
            <a href="mailto:bluemoondegreecollege@gmail.com">
              bluemoondegreecollege@gmail.com
            </a>
          </p>
        </div>

        {/* RIGHT: QUICK LINKS */}
        <div className="footer-right">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/college-details">Academics</Link></li>
            <li><Link to="/faculty">Faculty</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} Blue Moon Degree College. All Rights Reserved.
      </div>
    </footer>
  );
}

export default Footer;
